import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Visible = function Visible(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 19.1372C18.7402 19.1372 23.2891 13.7002 23.2891 12.0151C23.2891 10.3384 18.7319 4.90137 12 4.90137C5.35938 4.90137 0.710938 10.3384 0.710938 12.0151C0.710938 13.7002 5.35107 19.1372 12 19.1372ZM12.0083 16.5474C9.47656 16.5474 7.45947 14.4805 7.45117 12.0234C7.44287 9.4834 9.47656 7.49121 12.0083 7.49121C14.5234 7.49121 16.5571 9.4917 16.5571 12.0234C16.5571 14.4805 14.5234 16.5474 12.0083 16.5474ZM12.0083 13.7085C12.938 13.7085 13.71 12.9448 13.71 12.0234C13.71 11.0938 12.938 10.3218 12.0083 10.3218C11.062 10.3218 10.2983 11.0938 10.2983 12.0234C10.2983 12.9448 11.062 13.7085 12.0083 13.7085Z"
  })));
};

Visible.displayName = 'Visible';
export default Visible;